import { CommonModule } from '@angular/common';
import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-file-selection',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ],
  templateUrl: './file-selection.component.html',
  styleUrl: './file-selection.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileSelectionComponent),
      multi: true
    }
  ]
})
export class FileSelectionComponent implements ControlValueAccessor {
  @Input() label?: string | undefined = '';
  @Input() requiredField?: boolean = false;
  @Input() showError?: boolean = false;
  @Input({ required: true }) field!: FormlyFieldConfig;
  @Input() props: any;

  form = new FormGroup({
    file: new FormControl()
  });

  isDisabled: boolean = false;
  binaryId: string | null = null;
  fileName: string | null = null;
  uri: string | null = null;

  onChange: any = () => { };
  onTouch: any = () => { };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  resetFileName() {
    this.form.reset();
    this.fileName = null;
    this.uri = null;
  }

  onInputChangeEvent(eventTarget: EventTarget | null) {
    if (!eventTarget) {
      return;
    }

    let files = (eventTarget as HTMLInputElement).files;
    if (files && files.length > 0) {
      this.fileName = files[0].name
    } else {
      this.resetFileName();
    }

    this.onChange(files);
  }

  removeFile() {
    if (this.isDisabled) return;

    this.resetFileName();
    this.onChange(null);
  }

  writeValue(value: any): void {
    if (value === undefined || value === null) {
      this.resetFileName();
    } else {
      if (value.fileName) {
        this.binaryId = value.binaryId;
        this.fileName = value.fileName;
        this.uri = value.uri;
      }
    }
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    if (isDisabled) {
      this.form.disable({ onlySelf: false });
    } else {
      this.form.enable({ onlySelf: false });
    }
  }
}
